import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { createStructuredSelector } from 'reselect';
import { selectCurrentUser, selectCurrentUserRol } from '../../../redux/user/user-selectors';
import { selectProcesos, selectListaProcesos, selectProceso, selectListaEstados, selectEstados, selectEstado, selectListaDistritos, selectDistrito, selectParticipacion } from '../../../redux/menu/menu-selectors';
import { updateDetalle, updateListaEstados, updateEstado, updateListaDistritos, updateDistrito, updateListaProcesos } from '../../../redux/menu/menu-actions';
import { obtieneDistritos, obtieneProcesosDetalle } from '../../../redux/menu/menu-utils';
import { isObjectEmpty } from '../../../utils/funciones';
import VFiltrosText from './VFiltrosText';
import VFiltrosCombo from './VFiltrosCombo';
import '../../../css/filtrosMenu.scss';

class CFiltrosHeader extends React.Component { 

  constructor(props){
    super(props);

    this.state = {
      isHome: props.location.pathname === '/menuJDE' || props.location.pathname === '/bandeja' || props.location.pathname === '/juntaEjecutiva' || props.location.pathname === '/administrador',
      isOpenCombo: false
    }
  }

  seleccionaEstado = async(idEstado) => {
    this.props.cargando(true)
    // Se obtienen las propiedades de mapStateToProps
    const {estados, user} = this.props;

    const estado = estados[idEstado];

    // Actualizamos el idEstado
    this.props.updateEstado(idEstado);
    this.props.updateDetalle(0);

    // Si no hay un elemento del estado seleccionado, retornamos
    if(!estado || idEstado===0) {
      this.props.cargando(false)
      return;
    }

    // Si no hay procesos en el estado seleccionado
    if(!estado.procesos || isObjectEmpty(estado.procesos)) {
      this.props.updateListaProcesos(idEstado, await obtieneProcesosDetalle(idEstado, user.idDistrito, 0, "F"));
    }

    this.props.cargando(false)
  }

  seleccionaProceso = async(idDetalle) => {
    const { estado, user } = this.props;
    this.props.cargando(true)
    
    // Actualizamos el idDetalle
    this.props.updateDetalle(idDetalle);
    this.props.updateDistrito(user.idDistrito);

    if (idDetalle === null || idDetalle === undefined || idDetalle === 0) {
      this.props.cargando(false)
      return;
    }

    // Si no hay distritos en el detalle seleccionado (previamente cargados, para no volver a llamar a la capacidad del ws)
    if(idDetalle 
      && (!estado.procesos[idDetalle].distritos 
          || isObjectEmpty(estado.procesos[idDetalle].distritos))) {
            this.props.updateListaDistritos(idDetalle, estado.idEstado, 
              await obtieneDistritos(estado.procesos[idDetalle].idProcesoElectoral, estado.procesos[idDetalle].idDetalleProceso, "D", estado.idEstado, user.idDistrito, 0, "D"));
    }

    this.props.cargando(false)
  }

  seleccionaDistrito = async(idDistrito) => {
    this.props.cargando(true)
    this.props.updateDistrito(idDistrito);

    if (idDistrito === null || idDistrito === undefined) {
      this.props.cargando(false)
      return;
    }

    this.props.cargando(false)
  }

  handleChangeOpenCombo = () => {
    this.setState(prevState =>{
        return{
             ...prevState,
             isOpenCombo: !prevState.isOpenCombo
        }
     });
  }

  render(){
    const { isHome, isOpenCombo } = this.state;
    const { listaProcesos, proceso, listaEstados, estado, listaDistritos, distrito, rolUsuario, user } = this.props;

    const filtrosCombo = <VFiltrosCombo procesos={listaProcesos}
                                  proceso={proceso}
                                  estado={estado}
                                  distrito={distrito}
                                  usuario={user}
                                  rolUsuario={rolUsuario} 
                                  listaEstados={listaEstados} 
                                  listaDistritos={listaDistritos}
                                  seleccionaProceso={this.seleccionaProceso}
                                  seleccionaEstado={this.seleccionaEstado} 
                                  seleccionaDistrito={this.seleccionaDistrito} />

    return(
      <div className='filtros-menu-container'>
      {  isHome ? 
          filtrosCombo
        : 
          <div className='fmc-modulo'>
              <VFiltrosText proceso={proceso}
                          estado={estado}
                          distrito={distrito}
                          isOpenCombo={isOpenCombo}
                          handleChangeOpenCombo={this.handleChangeOpenCombo}/>
              {
                isOpenCombo ? 
                filtrosCombo
                : ''
              }
          </div>
      }
      </div>
    );
  
  }
}

const mapStateToProps = createStructuredSelector({
  user: selectCurrentUser,
  rolUsuario: selectCurrentUserRol,
  procesos: selectProcesos,
  listaProcesos: selectListaProcesos,
  proceso: selectProceso,
  listaEstados: selectListaEstados,
  estados: selectEstados,
  estado: selectEstado,
  listaDistritos: selectListaDistritos,
  distrito: selectDistrito,
  participacion: selectParticipacion
});

const mapDispatchToProps = dispatch => ({
  updateDetalle: (idDetalle) => dispatch(updateDetalle(idDetalle)),
  updateListaEstados: estados => dispatch(updateListaEstados(estados)),
	updateEstado: estado => dispatch(updateEstado(estado)),
  updateListaProcesos : (idEstado, procesos) => dispatch(updateListaProcesos(idEstado, procesos)),
  updateListaDistritos: (idDetalle, idEstado, distritos) => dispatch(updateListaDistritos(idDetalle, idEstado, distritos)),
	updateDistrito: distrito => dispatch(updateDistrito(distrito))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CFiltrosHeader));